export default {
  id: "page12",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",

  questions: [
    {
      type: "justlabel",
      number: "23",
      label: "Jak często używa Pan(i) następujące rodzaje produktów?",
      info:
        "Dla każdego rodzaju produktu (w wierszu) proszę zaznaczyć jedną odpowiedź pod odpowiednią częstotliwością.<br><br><strong><span class='has-text-danger'>UWAGA - INNA CZĘSTOTLIWOŚĆ NIŻ W PYT. 22</span></strong>"
    },
    {
      type: "choice_names",
      options: [
        "Raz w miesiącu lub częściej",
        "Raz na 2-3 miesiące",
        "2-3 razy w roku",
        "Rzadziej",
        "Wcale"
      ],
      topLine: true,
      bottomLine: true
    },
    {
      label:
        "Żelatyna używana do potraw pikantnych, słonych (nie do ciast, deserów)",
      type: "radio",
      id: "kategoria7_zelatynaSlone",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Twaróg mielony (sprzedawany w wiaderkach)",
      type: "radio",
      id: "kategoria7_twarog",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Produkty takie jak jogurty naturalne, kefiry, zsiadłe mleko ",
      type: "radio",
      id: "kategoria7_jogurt",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Śmietana kwaśna (12%; 18%)",
      type: "radio",
      id: "kategoria7_smietanaKwas",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Śmietanka słodka kremówka (30%; 36%)",
      type: "radio",
      id: "kategoria7_smietanaSlodka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Margaryna",
      type: "radio",
      id: "kategoria7_margaryna",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Bita śmietana w spray'u (gotowa do użycia)",
      type: "radio",
      id: "kategoria7_smietanaSpray",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Śnieżka / Bita śmietana w torebce do ubijania na mleku, używana do innych celów niż ciasta",
      type: "radio",
      id: "kategoria7_sniezka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Dekoracje do ciast i deserów (posypki, dekoracje czekoladowe, opłatkowe, pisaki)",
      type: "radio",
      id: "kategoria7_dekoracjeCiasta",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Sosy do lodów, deserów",
      type: "radio",
      id: "kategoria7_sosyDesery",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Ciasta z lodówki, np. ciasto francuskie",
      type: "radio",
      id: "kategoria7_ciastaLodowka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Ciasta  mrożone - gotowe do spożycia po rozmrożeniu (np. torty, rolady)",
      type: "radio",
      id: "kategoria7_ciastaMrozRozmroz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Ciasta  mrożone - wymagające upieczenia (np. strucle, ciasteczka)",
      type: "radio",
      id: "kategoria7_ciastaMrozPieczenie",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Gotowe ciasta paczkowane w folię (np. babki, strucle, drożdżowe, makowce)",
      type: "radio",
      id: "kategoria7_ciastaGotowe",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page12.js